"use client";

import { Navbar } from "@/components/Navbar/NavBar";
import { FAQ } from "@/features/marketing/faq/FAQ";
import { Footer } from "@/features/marketing/footer/Footer";
import { Pricing } from "@/features/marketing/pricing/Pricing";
import { WhatsIncluded } from "@/features/marketing/whats-included/WhatsIncluded";
import TrialBanner from "@/features/marketing/trial-banner/TrialBanner";
import { ScrollReveal } from "@/components/ui/PageTransition";

export default function WelcomePage() {
  return (
    <div className="min-h-screen bg-background flex flex-col">
      <Navbar />
      <main className="flex-1">
        <Pricing />
        <ScrollReveal>
          <WhatsIncluded />
        </ScrollReveal>
        <ScrollReveal>
          <FAQ />
        </ScrollReveal>
        <ScrollReveal>
          <TrialBanner variant="fullWidth" />
        </ScrollReveal>
        <Footer />
      </main>
    </div>
  );
}
